import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGiftcard: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="giftcard, present"><path d="M14 4.75V12M14 12V19.25M14 12H21.25M14 12H2.75M14 12L16.75 9.25M14 12L11.25 9.25M14 12L16.75 14.75M14 12L11.25 14.75M2.75 4.75H21.25V19.25H2.75V4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconGiftcard;
